<template>
  <div class="popup-content">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.popup-content {
  position: relative;
  min-width: 310px;
  max-width: 400px;
  background: #fff;
  border: 1px solid #CBD5E1;
  border-radius: 16px;
  padding: 16px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  color: #09090B;
  z-index: 100;
}
</style>
